import { render, staticRenderFns } from "./MedicalInsuranceLevelAdd.vue?vue&type=template&id=74aedf98&"
import script from "./MedicalInsuranceLevelAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports